export const SELECTOR_ID = "select";
export const ACTION_ID = "actions";
export const ROW_DND_DRAG_HANDLE_ID = "row-dnd-drag-handle";
export const ACTIVE_TAB = "ig_activeTab";
export const SELECTOR_ID_COL_SIZE = 32;
export const ACTION_ID_COL_SIZE = 50;
export const DEFAULT_COLUMN_SIZE = 250;
export const MIN_COLUMN_SIZE = 150; // Used for resizing feature
export const LOADING_SKELETON_COL_SIZE = 300;

export enum Button_Names {
  Save_Changes = "Save Changes",
  Save = "Save",
  Reset = "Reset",
  Cancel = "Cancel",
  Discard_Change = "Discard",
  Submit = "Submit",
  Next = "Next",
  Remove = "Remove",
  Send = "Send",
  Upload = "Upload",
  Add = "Add",
  UNSAVED_CHANGES = "You have unsaved changes",
}

export enum Action_Type {
  Add = "Add",
  Delete = "Delete",
}

export const GLOBAL_ERROR_MESSAGE =
  "Something went wrong. Please try again later.";

export const DELETE_CONFIRMATION_CONSTANTS = {
  title: "Are you sure?",
  btnName: "Yes, Delete It",
  cancelName: "No, Cancel",
  yesCancel: "Yes, Cancel It",
  optionTitle: "If you delete this option you cannot restore it",
};

export enum REQUEST_METHODS {
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH",
  GET = "GET",
}

export const GENERAL_KEYS = {
  Id: "id",
};
